import { render, staticRenderFns } from "./CoozzyBullhornIcon.vue?vue&type=template&id=1e94ef1a&scoped=true"
import script from "./CoozzyBullhornIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBullhornIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBullhornIcon.vue?vue&type=style&index=0&id=1e94ef1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94ef1a",
  null
  
)

export default component.exports